import React from "react";
import ImageClassificationDataLabellingPage from "../ImageClassificationDataLabellingPage";
import ObjectDetectionDataLabellingPage from "../ObjectDetectionDataLabellingPage";
import SegmentationDataLabellingPage from "../SegmentationDataLabellingPage";
import { useParams } from "react-router-dom";
import SegmentationNewLabellingPage from "../SegmentationNewLabellingPage";

const DataLabellingSelectionPage = () => {
  
  const { project_type } = useParams();
  
  const getPage = () => {
    switch (project_type) {
      case "object_detection":
        return <ObjectDetectionDataLabellingPage />;
      case "image_classification":
        return <ImageClassificationDataLabellingPage />;
      case "segmentation":
        return <SegmentationDataLabellingPage />;
      case "object_detection_-_(clarifier)":
        return <ObjectDetectionDataLabellingPage />;
      case "image_classification_-_(clarifier)":
        return <ImageClassificationDataLabellingPage />;
      case "instance_segmentation_-_(clarifier)":
        return <SegmentationNewLabellingPage/>;
      case "semantic_segmentation_-_(clarifier)":
        return <SegmentationNewLabellingPage/>;
      case "3D-CT Object Detection":
        return <ObjectDetectionDataLabellingPage />;
      case "3d-ct_segmentation_-_(clarifier)":
        return <SegmentationDataLabellingPage />;
    }
  };

  console.log("tempprojectype from the data page", project_type);
  // return tempProjectTypePath === "object_detection" ? (
  //   <ObjectDetectionDataLabellingPage />
  // ) : (
  //   <ImageClassificationDataLabellingPage />
  // );

  return <React.Fragment>{getPage()}</React.Fragment>;
};

export default DataLabellingSelectionPage;
